import { gql } from '@apollo/client';

// --- External COM Queries ---

// List COM connections (RS232, etc.) for current account
// Fields include full COM config needed by RS232 Send dialog payload
export const EXTERNAL_COMS_QUERY = gql`
  query ExternalComs($first: Int, $after: String, $teamId: String, $query: QueryExternalComInput) {
    externalComs(first: $first, after: $after, teamId: $teamId, query: $query) {
      page {
        edges {
          cursor
          node {
            _id
            name
            path
            baudRate
            dataBits
            stopBits
            parity
            rtscts
            xon
            xoff
            eol
            encoding
            createdAt
            lastUpdatedDate
            teamId
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

// List COM commands (saved RS232 commands) for current account
// Used by RS232 Send dialog "Commands" accordion section multi-select
export const COM_COMMANDS_QUERY = gql`
  query ComCommands($first: Int, $after: String, $teamId: String) {
    comCommands(first: $first, after: $after, teamId: $teamId) {
      page {
        edges {
          cursor
          node {
            _id
            name
            value
            eol
            encoding
            createdAt
            lastUpdatedDate
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

// List COM command templates
export const COM_COMMAND_TEMPLATES_QUERY = gql`
  query ComCommandTemplates(
    $first: Int
    $after: String
    $teamId: String
    $query: QueryComCommandTemplateInput
  ) {
    comCommandTemplates(first: $first, after: $after, teamId: $teamId, query: $query) {
      page {
        edges {
          cursor
          node {
            _id
            name
            items {
              action
              value
            }
            createdAt
            lastUpdatedDate
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

// --- External COM Mutations ---
// Migrated from Meteor DDP collection mutations (insert/update/remove).
// Save mutations: pass _id in payload to update, omit _id to create.
// Delete mutations: delete by _id (scoped to team+account on backend).

export const SAVE_EXTERNAL_COM = gql`
  mutation SaveExternalCom($payload: SaveExternalComInput!, $teamId: String) {
    saveExternalCom(payload: $payload, teamId: $teamId) {
      _id
      name
      path
    }
  }
`;

export const DELETE_EXTERNAL_COM = gql`
  mutation DeleteExternalCom($_id: String!, $teamId: String) {
    deleteExternalCom(_id: $_id, teamId: $teamId)
  }
`;

export const SAVE_COM_COMMAND = gql`
  mutation SaveComCommand($payload: SaveComCommandInput!, $teamId: String) {
    saveComCommand(payload: $payload, teamId: $teamId) {
      _id
      name
      value
    }
  }
`;

export const DELETE_COM_COMMAND = gql`
  mutation DeleteComCommand($_id: String!, $teamId: String) {
    deleteComCommand(_id: $_id, teamId: $teamId)
  }
`;

export const SAVE_COM_COMMAND_TEMPLATE = gql`
  mutation SaveComCommandTemplate($payload: SaveComCommandTemplateInput!, $teamId: String) {
    saveComCommandTemplate(payload: $payload, teamId: $teamId) {
      _id
      name
    }
  }
`;

export const DELETE_COM_COMMAND_TEMPLATE = gql`
  mutation DeleteComCommandTemplate($_id: String!, $teamId: String) {
    deleteComCommandTemplate(_id: $_id, teamId: $teamId)
  }
`;

// --- COM Log (Analytics / Report History) ---

export const COM_LOG_CREDENTIALS_QUERY = gql`
  query ComLogCredentials {
    comLogCredentials
  }
`;

export const UPDATE_COM_LOG_SETTINGS = gql`
  mutation UpdateComLogSettings($payload: UpdateComLogSettingsInput!) {
    updateComLogSettings(payload: $payload)
  }
`;

export const TEST_COM_LOG_S3_CONNECTION = gql`
  mutation TestComLogS3Connection($payload: TestComLogS3ConnectionInput!) {
    testComLogS3Connection(payload: $payload)
  }
`;

export const COM_LOG_REPORTS_QUERY = gql`
  query ComLogReports($limit: Int, $offset: Int) {
    comLogReports(limit: $limit, offset: $offset) {
      items {
        _id
        file
        startDate
        endDate
        createdAt
        exportType
        storeSource
        status
        timezone
        timezoneName
        bucket
        region
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const RUN_COM_LOG_REPORT = gql`
  mutation RunComLogReport($payload: RunComLogReportInput!) {
    runComLogReport(payload: $payload)
  }
`;

export const COM_LOG_REPORT_DOWNLOAD_URL = gql`
  mutation ComLogReportDownloadUrl($payload: ComLogReportDownloadUrlInput!) {
    comLogReportDownloadUrl(payload: $payload)
  }
`;
